import React, { Component } from 'react'
import styles from './profile.styles'
import injectSheet from 'react-jss'
import ProfileInfo from './profile-info/profile-info'
import Paper from 'pobble-components/dist/paper'
import ContentHolder from '../../../content-holder/content-holder'
import LoadingScreen from './loading-screen/loading-screen'
import Permission from './profile-permission/profile-permission'

class Profile extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, showLoadingScreen, showProfile } = this.props
    return (
      <div className={classes.container}>
        <ContentHolder className={classes.content}>
          <Paper>
            {showLoadingScreen && <LoadingScreen />}
            {showProfile && <ProfileInfo />}
          </Paper>
          <Paper>{showProfile && <Permission />}</Paper>
        </ContentHolder>
      </div>
    )
  }
}

export default injectSheet(styles)(Profile)
